import type { CountryType, Nullable } from "../@types/generic";
import { isAvailableCountry } from "./availableCountries";

const ALLOWED_AT = [
    ".at.qa.wetter.com",
    "at.stage.wetter.com",
    "at.wetter.com",
    "at.localhost",
];
const ALLOWED_CH = [
    ".ch.qa.wetter.com",
    "ch.stage.wetter.com",
    "ch.wetter.com",
    "ch.localhost",
];

export const extractCountry = (
    hostname?: Nullable<string>,
    pathname?: Nullable<string>,
    searchParams?: URLSearchParams
): CountryType => {
    const availableProductsViaPathname: Array<"pogoda24"> = ["pogoda24"];

    if (pathname) {
        const product = availableProductsViaPathname.find((_product) =>
            pathname.startsWith(`/${_product}/`)
        );

        if (product === "pogoda24") {
            const countryCode = searchParams
                ?.get("locale")
                ?.substring(0, 2)
                .toLowerCase();

            if (isAvailableCountry(countryCode)) {
                return countryCode;
            }

            return "pl";
        }
    }

    if (typeof hostname !== "string") {
        return "de";
    }

    if (ALLOWED_AT.some((host) => hostname.includes(host))) {
        return "at";
    } else if (ALLOWED_CH.some((host) => hostname.includes(host))) {
        return "ch";
    }

    return "de";
};
